import { render } from "./TextImage.vue?vue&type=template&id=d04a6034&scoped=true"
import script from "./TextImage.vue?vue&type=script&lang=js"
export * from "./TextImage.vue?vue&type=script&lang=js"

import "./TextImage.vue?vue&type=style&index=0&id=d04a6034&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d04a6034"]])

export default __exports__